import { ServerOptions } from 'commons/types'
import { Request } from 'commons/utils/request'
import { SarListPayload } from '~bank-bsa-reporting/types'

export const getListWebpage = (opts: SarListPayload) => Request.post(Request.urls.bank.sarListWebpage, opts)
export const remove = (opts: ServerOptions) => Request.delete(Request.urls.bank.sar, opts)
